export const PaperPlaneVector = () => (
	<svg width="87" height="67" viewBox="0 0 87 67" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M86.8991 11.3607L5.23535 37.4356L34.3819 51.793L86.8991 11.3607Z" fill="#82B536" />
		<path d="M85.2155 12.3213L26.0303 50.7354L52.6541 66.3803L85.2155 12.3213Z" fill="#82B536" />
		<path
			d="M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z"
			fill="#82B536"
		/>
		<path
			d="M85.2202 12.3213L85.0183 12.8057L34.3822 51.7929L28.707 48.9997L85.2202 12.3213Z"
			fill="#164B35"
		/>
		<path d="M33.6556 0.401855L0.109375 7.46549L11.1246 14.3596L33.6556 0.401855Z" fill="#BF63F3" />
		<path d="M32.9488 0.716797L7.84668 13.6009L16.1858 23.0581L32.9488 0.716797Z" fill="#BF63F3" />
		<path
			d="M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z"
			fill="#BF63F3"
		/>
		<path
			d="M32.9494 0.716797L32.8485 0.902469L11.1248 14.3597L8.98145 13.0196L32.9494 0.716797Z"
			fill="#AE2A19"
		/>
	</svg>
);
